import useStamdataApi from "core/hooks/useStamdataApi";
import UserFilterPermissions, { DirectUserPermissions } from "core/sharedmodels/userPermissions/userFilterPermissions";
import { useEffect, useState } from "react";
import useUser from "./useUser";

const initialDirectUserPermissions: DirectUserPermissions = {
    adgangTilAlleForloeb: false,
    afdelingIds: [],
    omraadeIds: [],
    praksisIds: [],
    regionIds: [],
    sygehusIds: [],
    specialeIds: [],
}

const initialFilterPermissions: UserFilterPermissions = {
    adgangTilAlleForloeb: false,
    afdelingIds: [],
    omraadeIds: [],
    praksisIds: [],
    regionIds: [],
    sygehusIds: [],
    specialeIds: [],
    directUserPermissions: initialDirectUserPermissions
}

const useUserFilterPermissions = () => {
    
    const {stamdataUserApi} = useStamdataApi();
    const { currentUser } = useUser();

    const [permissions, setPermissions] = useState<UserFilterPermissions>(initialFilterPermissions);
    const [isLoadingPermissions, setIsLoadingPermissions] = useState(true);

    useEffect(() => {
        
        const fetchPermissions = async () => {
            if(currentUser.Authenticated) {
                setPermissions(await stamdataUserApi.getUserFilterPermissions());
            }
            
            setIsLoadingPermissions(false);
        };

        fetchPermissions();
        
      }, [currentUser.Authenticated, stamdataUserApi]);

    return { permissions, isLoadingPermissions };
}
  
export default useUserFilterPermissions;